//emailService.js
import emailjs from "emailjs-com";

// CRA env (no quotes in .env)
const SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID;
const TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID; // (kept for employee creds)
const PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

// ✅ NEW: a separate template for employer welcome
const WELCOME_TEMPLATE_ID =
  process.env.REACT_APP_EMAILJS_WELCOME_TEMPLATE_ID || TEMPLATE_ID;

/**
 * Sends the employer welcome email (after successful subscription).
 * Template variables expected:
 *  - to_email, to_name, company_name, dashboard_url, support_email, from_name
 */
export async function sendEmployerWelcomeEmail({
  toEmail,
  toName = "",
  companyName = "",
  dashboardUrl = `${window.location.origin}/admin-dashboard`,
  supportEmail = "no-reply@oiiko.com",
  fromName = "Oiiko",
}) {
  const params = {
    to_email: toEmail,
    to_name: toName,
    company_name: companyName,
    dashboard_url: dashboardUrl,
    support_email: supportEmail,
    from_name: fromName,
  };

  try {
    await emailjs.send(SERVICE_ID, WELCOME_TEMPLATE_ID, params, PUBLIC_KEY);
    console.log("✅ Welcome email sent to", toEmail);
  } catch (err) {
    console.error("❌ Welcome email failed:", err?.message || err);
  }
}

export async function sendEmployeeInviteEmail({
  toEmail,
  toName = "",
  companyName = "",
  inviteLink,
  fromName = "Oiiko",
}) {
  try {
    const templateParams = {
      to_email: toEmail,
      to_name: toName,
      company_name: companyName,
      invite_link: inviteLink,
      from_name: fromName,
    };

    await emailjs.send(SERVICE_ID, TEMPLATE_ID, templateParams, PUBLIC_KEY);

    console.log("✅ Invite email sent to", toEmail);
  } catch (err) {
    console.error("❌ Invite email failed:", err?.message || err);
    throw new Error("Error sending invite email");
  }
}

/**
 * (existing) Sends credentials to an employee
 */
export async function sendEmailWithCredentials({
  toEmail,
  tempPassword,
  toName = "",
  companyName = "",
  replyTo = "",
  fromName = "Support",
}) {
  try {
    const templateParams = {
      to_email: toEmail,
      to_name: toName,
      password: tempPassword,
      company_name: companyName,
      reply_to: replyTo,
      from_name: fromName,
    };

    await emailjs.send(SERVICE_ID, TEMPLATE_ID, templateParams, PUBLIC_KEY);
    console.log("Email sent successfully to", toEmail);
  } catch (err) {
    console.error("Failed to send email:", err?.message || err);
    throw new Error("Error sending email");
  }
}
